import { HTTPError, type KyInstance } from 'ky';
import type { WholeFlatLinkPreviewResponse, WholeFlatLinkResponse } from './types';

const base = (roomId: string) => `api/v1/properties/${roomId}/whole-flat`;

/**
 * Wohnungsverbund aus Sicht des Zimmers. Eine Überschneidung beantwortet der Server mit 409 und
 * der Liste der Belegungen; `link` gibt sie als `linked: false` zurück statt zu werfen. Ein 409
 * ohne Liste (gleichzeitige Objektänderung) bleibt ein Fehler.
 */
export function buildWholeFlatApi(http: KyInstance) {
  return {
    preview: (roomId: string, wholeFlatId: string) =>
      http
        .get(`${base(roomId)}/preview`, { searchParams: { wholeFlatId } })
        .json<WholeFlatLinkPreviewResponse>(),
    link: async (roomId: string, wholeFlatId: string): Promise<WholeFlatLinkResponse> => {
      try {
        return await http
          .put(base(roomId), { json: { wholeFlatId } })
          .json<WholeFlatLinkResponse>();
      } catch (error) {
        if (error instanceof HTTPError && error.response.status === 409) {
          const body = (await error.response
            .clone()
            .json()
            .catch(() => null)) as Partial<WholeFlatLinkResponse> | null;
          if (Array.isArray(body?.conflicts)) return body as WholeFlatLinkResponse;
        }
        throw error;
      }
    },
    unlink: (roomId: string) => http.delete(base(roomId)).then(() => undefined),
  };
}

export type WholeFlatApi = ReturnType<typeof buildWholeFlatApi>;
